var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterFundoEscuro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-307.648 -245.006)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M319.648,245.006a12,12,0,1,0,12,12A12,12,0,0,0,319.648,245.006Zm0,23.193a11.193,11.193,0,1,1,11.193-11.193A11.193,11.193,0,0,1,319.648,268.2Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M319.649,247.086a9.921,9.921,0,1,0,9.92,9.92A9.92,9.92,0,0,0,319.649,247.086Zm4.735,7.489.008.316a6.95,6.95,0,0,1-10.7,5.855,5.225,5.225,0,0,0,.583.033,4.9,4.9,0,0,0,3.035-1.045,2.445,2.445,0,0,1-2.283-1.7,2.353,2.353,0,0,0,.46.045,2.453,2.453,0,0,0,.644-.086,2.447,2.447,0,0,1-1.961-2.4v-.03a2.443,2.443,0,0,0,1.107.307,2.447,2.447,0,0,1-.756-3.263,6.939,6.939,0,0,0,5.038,2.554,2.445,2.445,0,0,1,4.165-2.229,4.93,4.93,0,0,0,1.554-.593A2.459,2.459,0,0,1,324.2,253.7a4.87,4.87,0,0,0,1.4-.385A4.884,4.884,0,0,1,324.384,254.575Z",
    transform: "translate(0 0)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterFundoEscuro);
export default __webpack_public_path__ + "static/media/twitter_fundo_escuro.11a275f1a2c81563bdd4742f9ee7c98f.svg";
export { ForwardRef as ReactComponent };